import BasePage from "@/infrastructure/BasePage/basePage.component";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

type PageItemProps = {
  // TODO: add props here
};

const PageItem: React.FC<PageItemProps> = (props) => {
  const { t } = useTranslation();
  const { itemID } = useParams();

  return (
    <BasePage currPage="item">
      <div className="h-full overflow-y-auto">
        <h1 className="mt-2 mb-3 text-center text-3xl font-bold">
          {t("Order No.")} {itemID}
        </h1>
      </div>
    </BasePage>
  );
};

export default PageItem;
